import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from '../../../common/components/runtime-context';
import Pagination from '../pagination-regular';
import CreatePostButton from '../create-post-button';
import PostListItem from '../post-list-item';
//import { changePage } from '../../actions/change-page';
import Loader from '../loader';
import { POSTS_PER_PAGE } from '../../constants/pagination';
import styles from './post-list.scss';
import { SortingSelectCategoryPageDesktop } from '../sorting-select-category';

class PostListLarge extends Component {
  constructor(props) {
    super(props);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  handlePageChange = ({ page, buttonType }) => {
    this.props.onPageChange(page);
    this.props.changePage({
      page,
      meta: {
        bi: {
          buttonType,
        },
      },
    });
  };

  renderHeader() {
    const { category, showCreatePostAction, entityCount, page } = this.props;

    if (!showCreatePostAction && entityCount <= POSTS_PER_PAGE) {
      return <div className={styles.largeHeader} />;
    }

    return (
      <div className={styles.largeHeader}>
        <div>
          <Pagination
            page={page}
            entityCount={entityCount}
            showPerPage={POSTS_PER_PAGE}
            onChange={this.handlePageChange}
            buildPageUrl={this.props.buildPageUrl}
          />
        </div>
        <div className={styles.sortSelectContainer}>
          <SortingSelectCategoryPageDesktop />
        </div>
        <div>
          {showCreatePostAction && <CreatePostButton categorySlug={category.slug} isSmall />}
        </div>
      </div>
    );
  }

  renderPosts = () =>
    this.props.posts.map(post => (
      <div className={styles.listItem} key={post._id} id={post._id}>
        <PostListItem
          type={PostListItem.LARGE}
          post={post}
          onLikeClick={this.props.onLikeClick}
          showCategoryLink={this.props.showCategoryLink}
        />
      </div>
    ));

  render() {
    const { isLoading, isLoaded } = this.props;
    return (
      <div className={styles.large}>
        {isLoaded && this.renderHeader()}
        {isLoading ? <Loader /> : this.renderPosts()}
      </div>
    );
  }
}

PostListLarge.propTypes = {
  category: PropTypes.object,
  page: PropTypes.number,
  entityCount: PropTypes.number,
  posts: PropTypes.array.isRequired,
  onLikeClick: PropTypes.func,
  showCreatePostAction: PropTypes.bool,
  onPageChange: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isLoaded: PropTypes.bool,
  showCategoryLink: PropTypes.bool,
  buildPageUrl: PropTypes.func,
};

const mapRuntimeToProps = (state, ownProps, actions) => ({
  changePage: actions.changePage,
});

export default connect(mapRuntimeToProps)(PostListLarge);
